const adjustDate = (aMomentObject) => aMomentObject.format('YYYY-MM-DD')

const adjustTime = (aMomentObject) => aMomentObject.format('HH:mm:ss')

const adjustDateRange = (filters) => {
  const { endDate, endHour, startDate, startHour, ...props } = filters

  const fim = `${adjustDate(endDate)} ${
    endHour ? adjustTime(endHour) : '23:59:59'
  }`
  const inicio = `${adjustDate(startDate)} ${
    startHour ? adjustTime(startHour) : '00:00:00'
  }`

  return {
    ...props,
    fim,
    inicio
  }
}

export default adjustDateRange
